"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _lodash2 = _interopRequireDefault(require("lodash.debounce"));

var _CallbackContext = _interopRequireDefault(require("../context/CallbackContext"));

var _Pin = _interopRequireWildcard(require("../components/Annotations/Pin"));

var _Drawing = _interopRequireDefault(require("../components/Annotations/Drawing"));

var _Highlight = _interopRequireDefault(require("../components/Annotations/Highlight"));

var _Replace = _interopRequireDefault(require("../components/Annotations/Replace"));

var _Strikethrough = _interopRequireDefault(require("../components/Annotations/Strikethrough"));

var _Insert = _interopRequireDefault(require("../components/Annotations/Insert"));

var _utils = require("../components/Annotations/utils");

var _AnnotationsView = _interopRequireDefault(require("../style/AnnotationsView.scss"));

var _constants = require("../constants");

var _FadeOut = _interopRequireDefault(require("../components/FadeOut"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DIAMETER = 24;
var POINTER_EVENTS_SUPPORTED = !!window.PointerEvent;
/**
 * Annotations component
 */

var Annotations = /*#__PURE__*/function (_React$Component) {
  _inherits(Annotations, _React$Component);

  var _super = _createSuper(Annotations);

  /**
   * Constructor for component
   * @param {object} props - props sent to the component
   * @returns {undefined}
   */
  function Annotations(props) {
    var _this;

    _classCallCheck(this, Annotations);

    _this = _super.call(this, props);
    _this.state = {
      curDrawing: [],
      curLine: [],
      hasPlaceHolder: false,
      offsetX: 0,
      offsetY: 0,
      showTempPin: false,
      pinSize: 'S'
    };
    _this.pointerEventsCache = [];
    _this.addEventListeners = _this.addEventListeners.bind(_assertThisInitialized(_this));
    _this.renderAnnotation = _this.renderAnnotation.bind(_assertThisInitialized(_this));
    _this.handleOverlayClick = _this.handleOverlayClick.bind(_assertThisInitialized(_this));
    _this.handleAnnotationDown = _this.handleAnnotationDown.bind(_assertThisInitialized(_this));
    _this.handleAnnotationHover = _this.handleAnnotationHover.bind(_assertThisInitialized(_this));
    _this.handleOverlayRef = _this.handleOverlayRef.bind(_assertThisInitialized(_this));
    _this.handleCursorMarkerRef = _this.handleCursorMarkerRef.bind(_assertThisInitialized(_this));
    _this.handleCursorMarkerMove = _this.handleCursorMarkerMove.bind(_assertThisInitialized(_this));
    _this.handleGestureStart = _this.handleGestureStart.bind(_assertThisInitialized(_this));
    _this.handleGestureMove = _this.handleGestureMove.bind(_assertThisInitialized(_this));
    _this.handleGestureEnd = _this.handleGestureEnd.bind(_assertThisInitialized(_this));
    _this.handleOverlayEnter = _this.handleOverlayEnter.bind(_assertThisInitialized(_this));
    _this.handleOverlayLeave = _this.handleOverlayLeave.bind(_assertThisInitialized(_this));
    _this.handleTempPinVisibility = _this.handleTempPinVisibility.bind(_assertThisInitialized(_this));
    _this.calculateCurLine = (0, _lodash2.default)(_this.calculateCurLine, 10, {
      leading: true,
      maxWait: 30
    });
    return _this;
  }
  /**
   * Private method to determine if a temporary annotation is present
   * @returns {undefined}
   */


  _createClass(Annotations, [{
    key: "_hasTempAnnotation",
    value: function _hasTempAnnotation() {
      var _this$props = this.props,
          annotationLocationCoordinates = _this$props.annotationLocationCoordinates,
          isPlacingAnnotation = _this$props.isPlacingAnnotation,
          registeredSectionIds = _this$props.registeredSectionIds,
          sectionId = _this$props.sectionId;
      return annotationLocationCoordinates && !isPlacingAnnotation && (!sectionId && registeredSectionIds.length === 1 || sectionId === annotationLocationCoordinates.sectionId);
    }
    /**
     * Private method to determine if an annotation can be moved
     * @param {String} annotationId - ID of a annotation
     * @returns {undefined}
     */

  }, {
    key: "_canMoveAnnotation",
    value: function _canMoveAnnotation(annotationId) {
      var _this$props2 = this.props,
          comments = _this$props2.comments,
          imsData = _this$props2.imsData,
          isOffline = _this$props2.isOffline;
      var selectedAnnotation = comments.find(function (comment) {
        return comment.id === annotationId;
      });
      return !isOffline && selectedAnnotation && imsData.id === selectedAnnotation.creator.id && (0, _lodash.default)(selectedAnnotation, 'target.selector.subtype') === 'note' || annotationId === 'annotation-placeholder';
    }
    /**
     * Private method to determine if an event occured inside the overlay
     * @param {EventObject} evt - javascript event object
     * @param {string} nodeIdToMatch - node ID of overlay to match if event occurect inside a specific overlay. Requires nodeId prop to be populated.
     * @returns {undefined}
     */

  }, {
    key: "_insideOverlay",
    value: function _insideOverlay(evt, nodeIdToMatch) {
      var _this$props$currentDo = this.props.currentDocument,
          currentDocument = _this$props$currentDo === void 0 ? document : _this$props$currentDo;

      var _getClientCoordinates = (0, _utils.getClientCoordinatesFromEvent)(evt),
          x = _getClientCoordinates.x,
          y = _getClientCoordinates.y; // element the touch event landed on


      var target = currentDocument.elementFromPoint(x, y); // return false unless the target is either the overlay or one of the annotation types (e.g.: pin)

      if (!target || target.getAttribute('id') !== _constants.ANNOTATION_COMPONENT_ID && !target.dataset.annotationtype) {
        return false;
      }

      var rect = target.getBoundingClientRect();

      if (x >= rect.left && x <= rect.left + rect.width) {
        if (y >= rect.top && y <= rect.top + rect.height) {
          if (nodeIdToMatch === undefined || target.dataset.nodeid === undefined || nodeIdToMatch.toString() === target.dataset.nodeid) {
            return true;
          }
        }
      }

      return false;
    }
    /**
     * Helper to decide if current overlay is "active"
     * @param {Object} props - props object
     * @returns {boolean} indication if current overlay is "active"
     */

  }, {
    key: "_isActiveOverlay",
    value: function _isActiveOverlay(props) {
      var annotationsMultiPageEnabled = props.annotationsMultiPageEnabled,
          assetData = props.assetData,
          nodeId = props.nodeId;
      return !annotationsMultiPageEnabled || assetData.nodeId === nodeId;
    }
    /**
     * Helper to filter to comments that should be used for rendering
     * @returns {Array} array of valid comments based on current configuration
     */

  }, {
    key: "_getFilteredComments",
    value: function _getFilteredComments() {
      var _this$props3 = this.props,
          annotationsMultiPageEnabled = _this$props3.annotationsMultiPageEnabled,
          _this$props3$comments = _this$props3.comments,
          comments = _this$props3$comments === void 0 ? [] : _this$props3$comments,
          nodeId = _this$props3.nodeId,
          registeredSectionIds = _this$props3.registeredSectionIds,
          sectionId = _this$props3.sectionId;
      var annotations = comments.filter(function (comment) {
        var curSectionId = (0, _lodash.default)(comment, 'target.selector.sectionId') || 'root';
        return (comment.pinNum || comment.hasShapeAnnotation || comment.hasHighlightAnnotation || comment.hasInsertAnnotation || comment.hasReplaceAnnotation || comment.hasStrikethroughAnnotation) && registeredSectionIds.indexOf(curSectionId) > -1;
      });

      if (sectionId) {
        annotations = annotations.filter(function (comment) {
          return (0, _lodash.default)(comment, 'target.selector.sectionId') === sectionId;
        });
      } else {
        annotations = annotations.filter(function (comment) {
          return (0, _lodash.default)(comment, 'target.selector.sectionId') === undefined;
        });
      }

      if (annotationsMultiPageEnabled && nodeId !== undefined) {
        annotations = annotations.filter(function (comment) {
          return (0, _lodash.default)(comment, 'target.selector.node.id') === nodeId;
        });
      }

      return annotations;
    }
    /**
     * Helper to decide if annotation can be rendered within overlay
     * @param {Object} annotation - comment object
     * @returns {boolean} indication if annotation can be rendered within overlay
     */

  }, {
    key: "_canRenderAnnotation",
    value: function _canRenderAnnotation(annotation) {
      var _annotation$target, _annotation$target$se, _this$_element;

      var _this$props4 = this.props,
          scaleFactorX = _this$props4.scaleFactorX,
          scaleFactorY = _this$props4.scaleFactorY;
      var annotationType = (_annotation$target = annotation.target) === null || _annotation$target === void 0 ? void 0 : (_annotation$target$se = _annotation$target.selector) === null || _annotation$target$se === void 0 ? void 0 : _annotation$target$se.subtype;

      var _ref = ((_this$_element = this._element) === null || _this$_element === void 0 ? void 0 : _this$_element.getBoundingClientRect()) || {},
          height = _ref.height,
          width = _ref.width;

      if (height && width) {
        if (annotationType === 'note') {
          var x = annotation.target.selector.noteX * scaleFactorX;
          var y = annotation.target.selector.noteY * scaleFactorY;
          return x < width && y < height;
        }

        var boundingBox = annotation.target.selector.boundingBox;
        var right = boundingBox[2] * scaleFactorX;
        var bottom = boundingBox[3] * scaleFactorY;
        return right < width && bottom < height;
      }

      return true;
    }
    /**
     * Handle setting a reference to the overlay element
     * @param {Element} ref - HTML element for the overlay
     * @returns {undefined}
     */

  }, {
    key: "handleOverlayRef",
    value: function handleOverlayRef(ref) {
      if (this._element) {
        this.removeEventListeners(this._element);
      }

      this._element = ref;

      if (this._element) {
        this.addEventListeners(this._element);
      }
    }
    /**
     * Handle setting a reference to the cursor marker element
     * @param {Element} ref - HTML element for the cursor marker
     * @returns {undefined}
     */

  }, {
    key: "handleCursorMarkerRef",
    value: function handleCursorMarkerRef(ref) {
      this._cursorMarker = ref;
    }
    /**
     * Adds necessary event lsiteners for an annotation overlay.
     * @param {Element} ref - HTML element for the overlay
     * @return {undefined}
     */

  }, {
    key: "addEventListeners",
    value: function addEventListeners(ref) {
      if (POINTER_EVENTS_SUPPORTED) {
        ref.addEventListener('pointermove', this.handleGestureMove, true);
        ref.addEventListener('pointercancel', this.handleGestureEnd, true); // iOS still fires touch events with pointer events so will have to
        // handle move gestures to prevent default scrolling behavior

        ref.addEventListener('touchmove', this.handleGestureMove, true);
      } else {
        ref.addEventListener('touchmove', this.handleGestureMove, true);
        ref.addEventListener('touchcancel', this.handleGestureEnd, true);
        ref.addEventListener('mousemove', this.handleGestureMove, true);
      }
    }
    /**
     * Remove events listeners for an annotation overlay.
     * @param {Element} ref - HTML element for the overlay
     * @return {undefined}
     */

  }, {
    key: "removeEventListeners",
    value: function removeEventListeners(ref) {
      if (POINTER_EVENTS_SUPPORTED) {
        ref.removeEventListener('pointermove', this.handleGestureMove, true);
        ref.removeEventListener('pointercancel', this.handleGestureEnd, true);
        ref.removeEventListener('touchmove', this.handleGestureMove, true);
      } else {
        ref.removeEventListener('touchmove', this.handleGestureMove, true);
        ref.removeEventListener('touchcancel', this.handleGestureEnd, true);
        ref.removeEventListener('mousemove', this.handleGestureMove, true);
      }
    }
    /**
     * Called when component is added to DOM.
     * @returns {undefined}
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props5 = this.props,
          registerSectionId = _this$props5.registerSectionId,
          sectionId = _this$props5.sectionId;

      if (this._isActiveOverlay(this.props)) {
        this._attachGlobalListeners();
      }

      registerSectionId(sectionId || 'root');
    }
    /**
     * Attach global listeners
     * @return {undefined}
     */

  }, {
    key: "_attachGlobalListeners",
    value: function _attachGlobalListeners() {
      var _this$props$currentDo2 = this.props.currentDocument,
          currentDocument = _this$props$currentDo2 === void 0 ? document : _this$props$currentDo2;
      var curWindow = currentDocument.defaultView;

      if (!this.listenersAttached) {
        if (POINTER_EVENTS_SUPPORTED) {
          curWindow.addEventListener('pointerdown', this.handleTempPinVisibility, true);
          curWindow.addEventListener('pointerup', this.handleTempPinVisibility, true);
        } else {
          curWindow.addEventListener('touchstart', this.handleTempPinVisibility, true);
          curWindow.addEventListener('touchend', this.handleTempPinVisibility, true);
        }

        this.listenersAttached = true;
      }
    }
    /**
     * Remove global listeners
     * @return {undefined}
     */

  }, {
    key: "_removeGlobalListeners",
    value: function _removeGlobalListeners() {
      var _this$props$currentDo3 = this.props.currentDocument,
          currentDocument = _this$props$currentDo3 === void 0 ? document : _this$props$currentDo3;
      var curWindow = currentDocument.defaultView;

      if (this.listenersAttached) {
        if (POINTER_EVENTS_SUPPORTED) {
          curWindow.removeEventListener('pointerdown', this.handleTempPinVisibility, true);
          curWindow.removeEventListener('pointerup', this.handleTempPinVisibility, true);
        } else {
          curWindow.removeEventListener('touchstart', this.handleTempPinVisibility, true);
          curWindow.removeEventListener('touchend', this.handleTempPinVisibility, true);
        }

        this.listenersAttached = false;
      }
    }
    /**
     * React lifecycle method invoked when component is updated.
     * @param {Object} prevProps - previous values of props before update
     * @return {undefined}
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var _this$props6 = this.props,
          annotationsEnabled = _this$props6.annotationsEnabled,
          ccxIngest = _this$props6.ccxIngest,
          hasAnnotationLocation = _this$props6.hasAnnotationLocation,
          newAnnotationType = _this$props6.newAnnotationType,
          remapCommentNodes = _this$props6.remapCommentNodes,
          sectionId = _this$props6.sectionId,
          viewingUnmapped = _this$props6.viewingUnmapped;

      var isActiveOverlay = this._isActiveOverlay(this.props);

      if (isActiveOverlay) {
        this._attachGlobalListeners();
      } else {
        this._removeGlobalListeners();
      }

      if (hasAnnotationLocation && !prevProps.hasAnnotationLocation && isActiveOverlay) {
        ccxIngest.fireEvent({
          event: {
            subcategory: "".concat(newAnnotationType, "-comment"),
            type: 'click',
            subtype: newAnnotationType
          }
        });
      }

      var newSectionId = sectionId;

      if (prevProps.sectionId !== newSectionId) {
        prevProps.registerSectionId(prevProps.sectionId || 'root', false);
        prevProps.registerSectionId(newSectionId || 'root');
      }

      if (prevProps.hasAnnotationLocation && prevProps.annotationLocationCoordinates.subtype === 'shape' && !hasAnnotationLocation) {
        this.setState({
          curDrawing: [],
          curLine: []
        });
      }

      if (annotationsEnabled && !viewingUnmapped) {
        var unmapObject = {};

        this._getFilteredComments().forEach(function (annotation) {
          if (!_this2._canRenderAnnotation(annotation)) {
            unmapObject[annotation.id] = _constants.UNMAPPED_GLOBAL_ID;
          }
        });

        if (Object.keys(unmapObject).length) {
          remapCommentNodes(unmapObject);
        }
      }
    }
    /**
     * Called when component is about to be removed from DOM.
     * @returns {undefined}
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props7 = this.props,
          assetData = _this$props7.assetData,
          annotationLocationNodeId = _this$props7.annotationLocationNodeId,
          annotationsMultiPageEnabled = _this$props7.annotationsMultiPageEnabled,
          registerSectionId = _this$props7.registerSectionId,
          saveAnnotationLocation = _this$props7.saveAnnotationLocation,
          sectionId = _this$props7.sectionId,
          setAnnotationMode = _this$props7.setAnnotationMode; // When in multipage mode, we dont want to remove temp pins any overlay is removed.

      var tempPinIsValid = false;

      if (assetData.validNodes) {
        // when using node index, we only care if its in the range of valid nodes.
        // when using ids, we make sure the node id exists in the valid nodes array.
        tempPinIsValid = assetData.useNodeIndex ? assetData.validNodes.length - 1 >= annotationLocationNodeId : assetData.validNodes.map(function (_ref2) {
          var id = _ref2.id;
          return id;
        }).includes(annotationLocationNodeId);
      }

      if (this._hasTempAnnotation() && !(annotationsMultiPageEnabled && tempPinIsValid)) {
        saveAnnotationLocation();
        setAnnotationMode(false);
      }

      this._removeGlobalListeners();

      this.removeEventListeners(this._element);
      window.requestAnimationFrame(function () {
        registerSectionId(sectionId || 'root', false);
      });
    }
    /**
     * Handles the start of gestures.
     * @param {SyntheticEvent} evt - one of touchstart, pointerdown, or mousedown event
     * @return {undefined}
     */

  }, {
    key: "handleGestureStart",
    value: function handleGestureStart(evt) {
      if (evt.touches && evt.touches.length > 1) {
        return;
      }

      if (evt.pointerType) {
        this.pointerEventsCache.push(evt);

        if (this.pointerEventsCache.length > 1) {
          return;
        }
      }

      evt.preventDefault();
      var mouseUsed = evt.pointerType && evt.pointerType === 'mouse' || evt.type === 'mousedown'; // enlarge the pin size for non-mouse pointers

      if (!mouseUsed) {
        this.setState(function (_ref3) {
          var pinSize = _ref3.pinSize;

          if (pinSize !== 'L') {
            return {
              pinSize: 'L'
            };
          }

          return null;
        });
      }

      var _this$props8 = this.props,
          isPlacingAnnotation = _this$props8.isPlacingAnnotation,
          setSelectedAnnotationId = _this$props8.setSelectedAnnotationId,
          newAnnotationType = _this$props8.newAnnotationType,
          drawingNode = _this$props8.drawingNode,
          annotationsMultiPageEnabled = _this$props8.annotationsMultiPageEnabled,
          hasAnnotationLocation = _this$props8.hasAnnotationLocation,
          annotationLocationNodeId = _this$props8.annotationLocationNodeId,
          nodeId = _this$props8.nodeId,
          assetData = _this$props8.assetData,
          setDrawingNode = _this$props8.setDrawingNode;
      var _this$state = this.state,
          curDrawing = _this$state.curDrawing,
          curLine = _this$state.curLine;
      var annotationEl = evt.target.closest('[data-annotationid]');
      var annotationId = annotationEl && annotationEl.dataset.annotationid;
      setSelectedAnnotationId(annotationId);

      if (newAnnotationType === 'draw' && drawingNode === undefined && isPlacingAnnotation && (!annotationsMultiPageEnabled || !hasAnnotationLocation || annotationLocationNodeId === nodeId)) {
        setDrawingNode(annotationsMultiPageEnabled ? nodeId : assetData.nodeId);
        var newState = {
          curLine: []
        };

        if (curLine.length > 1) {
          var newCurDrawing = curDrawing.concat([]);
          newCurDrawing.push(curLine);
          newState.curDrawing = newCurDrawing;
        }

        this.setState(newState);
      }
    }
    /**
     * Handles gesture movements.
     * @param {Event} evt - one of touchmove, pointermove, or mousemove event
     * @return {undefined}
     */

  }, {
    key: "handleGestureMove",
    value: function handleGestureMove(evt) {
      if (evt.touches && evt.touches.length > 1) {
        return;
      }

      if (evt.pointerType) {
        if (this.pointerEventsCache.length > 1) {
          return;
        }
      } // if touch devices fire a `touchmove` event along with `pointermove` events,
      // just prevent its default scrolling behavior and return to avoid any conflict
      // between the two in processing an annotation


      if (POINTER_EVENTS_SUPPORTED && evt.type === 'touchmove') {
        evt.preventDefault();
        return;
      }

      var _this$props9 = this.props,
          isPlacingAnnotation = _this$props9.isPlacingAnnotation,
          newAnnotationType = _this$props9.newAnnotationType;
      var validAnnotationGesture = evt.touches && evt.touches.length === 1 || this.pointerEventsCache.length === 1 || evt.buttons === 1;

      if (validAnnotationGesture && isPlacingAnnotation) {
        evt.preventDefault();

        if (newAnnotationType === 'draw') {
          this.calculateCurLine(evt);
        }
      }
    }
    /**
     * Handles the end of gestures.
     * @param {Event} evt - one of touchend, pointerup, or mouseup event
     * @return {undefined}
     */

  }, {
    key: "handleGestureEnd",
    value: function handleGestureEnd(evt) {
      evt.preventDefault();

      if (evt.pointerType) {
        this.pointerEventsCache = [];
      }

      this.handleOverlayClick(evt);
      var _this$props10 = this.props,
          isPlacingAnnotation = _this$props10.isPlacingAnnotation,
          newAnnotationType = _this$props10.newAnnotationType,
          hoveredAnnotation = _this$props10.hoveredAnnotation,
          setHoveredAnnotation = _this$props10.setHoveredAnnotation,
          setSelectedAnnotationId = _this$props10.setSelectedAnnotationId;
      var annotationEl = evt.target.closest('[data-annotationid]');
      var annotationId = annotationEl && annotationEl.dataset.annotationid; // Unset the selected annotation after gesture ends

      setSelectedAnnotationId(null); // Check for hovered annotation

      if (annotationId) {
        if (annotationId !== hoveredAnnotation) {
          setHoveredAnnotation(annotationId);
        }
      } else {
        setHoveredAnnotation(null);
      }

      if (isPlacingAnnotation && newAnnotationType === 'draw') {
        this.endDrawing();
      }
    }
    /**
     * Handles pointerenter or mouseenter event.
     * @return {undefined}
     */

  }, {
    key: "handleOverlayEnter",
    value: function handleOverlayEnter() {
      var _this$props11 = this.props,
          newAnnotationType = _this$props11.newAnnotationType,
          isPlacingAnnotation = _this$props11.isPlacingAnnotation;

      if (newAnnotationType === 'pin' && isPlacingAnnotation) {
        this.setState({
          showTempPin: true,
          pinSize: 'S'
        });
      }
    }
    /**
     * Handles pointerleave or mouseleave event.
     * @return {undefined}
     */

  }, {
    key: "handleOverlayLeave",
    value: function handleOverlayLeave() {
      var _this$props12 = this.props,
          newAnnotationType = _this$props12.newAnnotationType,
          isPlacingAnnotation = _this$props12.isPlacingAnnotation;

      if (newAnnotationType === 'pin' && isPlacingAnnotation) {
        this.setState({
          showTempPin: false
        });
      }
    }
    /**
     * Checks where a gesture occurred and decides whether to show a temp pin or not.
     * @param {Event} evt - either a pointerdown/up or touchstart/end event
     * @return {undefined}
     */

  }, {
    key: "handleTempPinVisibility",
    value: function handleTempPinVisibility(evt) {
      var newAnnotationType = this.props.newAnnotationType;
      var insideOverlay = !!evt.target.closest("#".concat(_constants.ANNOTATION_COMPONENT_ID));
      var showTempPin = !!insideOverlay;

      if (!newAnnotationType || newAnnotationType === 'pin') {
        this.setState({
          showTempPin: showTempPin
        });
      }
    }
    /**
     * Handles callback for cursor marker moving.
     * @param {Event} evt - JavaScript event object
     * @returns {undefined}
     */

  }, {
    key: "handleCursorMarkerMove",
    value: function handleCursorMarkerMove(evt) {
      var _this$props13 = this.props,
          assetData = _this$props13.assetData,
          commentsListMinimized = _this$props13.commentsListMinimized,
          compactLayout = _this$props13.compactLayout,
          focusedInputInfo = _this$props13.focusedInputInfo,
          isPlacingAnnotation = _this$props13.isPlacingAnnotation,
          setCommentsListMinimized = _this$props13.setCommentsListMinimized,
          setTouchPressed = _this$props13.setTouchPressed,
          touchPressed = _this$props13.touchPressed;

      if (isPlacingAnnotation && (evt.touches || evt.pointerType && evt.poitnerType !== 'mouse')) {
        var inCommentingState = focusedInputInfo && focusedInputInfo[assetData.nodeId];

        if (compactLayout) {
          if (this.annotationTouchStartTimerId) {
            clearTimeout(this.annotationTouchStartTimerId);
            this.annotationTouchStartTimerId = null;
          }

          if (!commentsListMinimized && !inCommentingState) {
            setCommentsListMinimized(true);
          }
        }

        if (touchPressed) {
          setTouchPressed(false);
        }
      }
    }
    /**
     * Handle a click on the overlay
     * @param {EventObject} evt - javascript event object
     * @param {boolean} forceAnnotation - boolean to force annotation to be placed
     * @returns {undefined}
     */

  }, {
    key: "handleOverlayClick",
    value: function handleOverlayClick(evt) {
      var forceAnnotation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props14 = this.props,
          annotationColor = _this$props14.annotationColor,
          annotationLocationNodeId = _this$props14.annotationLocationNodeId,
          annotatingItmId = _this$props14.annotatingItmId,
          annotationsMultiPageEnabled = _this$props14.annotationsMultiPageEnabled,
          assetData = _this$props14.assetData,
          comments = _this$props14.comments,
          _this$props14$current = _this$props14.currentDocument,
          currentDocument = _this$props14$current === void 0 ? document : _this$props14$current,
          drawingNode = _this$props14.drawingNode,
          focusedInputInfo = _this$props14.focusedInputInfo,
          hasAnnotationLocation = _this$props14.hasAnnotationLocation,
          imageCapture = _this$props14.imageCapture,
          isPlacingAnnotation = _this$props14.isPlacingAnnotation,
          newAnnotationType = _this$props14.newAnnotationType,
          nodeId = _this$props14.nodeId,
          saveAnnotationLocation = _this$props14.saveAnnotationLocation,
          saveImageCoordinatesInfo = _this$props14.saveImageCoordinatesInfo,
          sectionId = _this$props14.sectionId,
          setAnnotationMode = _this$props14.setAnnotationMode,
          setTouchPressed = _this$props14.setTouchPressed,
          onPinDrop = _this$props14.onPinDrop;

      if (annotationsMultiPageEnabled && nodeId !== assetData.nodeId && !hasAnnotationLocation && (drawingNode === undefined || drawingNode === nodeId)) {
        var _ref4 = this.context || {},
            onNodeChange = _ref4.onNodeChange;

        onNodeChange(nodeId, sectionId);
      }

      if (this.moveTimer) {
        clearTimeout(this.moveTimer);
        this.moveTimer = null;
      }

      if (newAnnotationType === 'pin' && (isPlacingAnnotation || forceAnnotation)) {
        var _getPageCoordinatesFr = (0, _utils.getPageCoordinatesFromEvent)(evt),
            x = _getPageCoordinatesFr.x,
            y = _getPageCoordinatesFr.y;

        var bodyRect = currentDocument.body.getBoundingClientRect();

        var _getClientCoordinates2 = (0, _utils.getClientCoordinatesFromEvent)(evt),
            clientX = _getClientCoordinates2.x,
            clientY = _getClientCoordinates2.y;

        var target = currentDocument.elementFromPoint(clientX, clientY);
        var isAnnotationOverlay = false;
        var overlayRect;
        var overlayTop;
        var overlayLeft;
        var scaledX;
        var scaledY;
        var targetSectionId = target && target.dataset.sectionid;

        if (target.tagName === 'DIV' && target.getAttribute('id') === _constants.ANNOTATION_COMPONENT_ID) {
          isAnnotationOverlay = true;
        }

        if (isAnnotationOverlay) {
          overlayRect = target.getBoundingClientRect();
          overlayTop = overlayRect.top - bodyRect.top;
          overlayLeft = overlayRect.left - bodyRect.left;
          scaledX = (x - overlayLeft) / target.dataset.scalefactorx;
          scaledY = (y - overlayTop) / target.dataset.scalefactory;
        } else {
          overlayRect = this._element.getBoundingClientRect();
          overlayTop = overlayRect.top - bodyRect.top;
          overlayLeft = overlayRect.left - bodyRect.left;
          scaledX = (x - overlayLeft) / this.props.scaleFactorX;
          scaledY = (y - overlayTop) / this.props.scaleFactorY;
        }

        setTouchPressed(false);
        var inCommentingState = focusedInputInfo && focusedInputInfo[assetData.nodeId];
        var selectedComment = comments.find(function (comment) {
          return comment.id === annotatingItmId;
        });
        var newComment = annotatingItmId === 'root';
        var newPin = newComment || selectedComment && !selectedComment.pinNum;

        if (this._insideOverlay(evt) && (!annotationsMultiPageEnabled || !hasAnnotationLocation || annotationLocationNodeId === nodeId)) {
          // when in focused edit state on mobile, don't allow other pins to be moved
          if (!inCommentingState && isPlacingAnnotation || newPin || inCommentingState && focusedInputInfo[assetData.nodeId].id === annotatingItmId) {
            var targetNodeId = assetData.useNodeIndex ? Number(target.dataset.nodeid) : target.dataset.nodeid;

            if (newComment) {
              saveAnnotationLocation({
                noteX: scaledX - this.state.offsetX,
                noteY: scaledY - this.state.offsetY,
                sectionId: isAnnotationOverlay ? targetSectionId : sectionId,
                subtype: 'note',
                strokeColor: annotationColor
              }, annotationsMultiPageEnabled ? targetNodeId : undefined);
            } else {
              onPinDrop(assetData.id, selectedComment, {
                noteX: scaledX - this.state.offsetX,
                noteY: scaledY - this.state.offsetY,
                sectionId: isAnnotationOverlay ? targetSectionId : sectionId,
                subtype: 'note',
                strokeColor: (0, _lodash.default)(selectedComment, 'target.selector.strokeColor')
              }, annotationsMultiPageEnabled ? targetNodeId : undefined);
            }
          }

          if (imageCapture) {
            var backgroundY = 0;

            if (overlayTop > 0) {
              backgroundY = y - overlayTop;
            } else {
              backgroundY = y + overlayTop;
            }

            saveImageCoordinatesInfo({
              X: x - overlayLeft,
              backgroundY: backgroundY,
              sectionY: y - overlayRect.top,
              sectionId: sectionId || 'root'
            });
          }
        }

        setAnnotationMode(false);
      }
    }
    /**
     * Handle a mouseMOve on the overlay
     * @param {EventObject} evt - javascript event object
     * @returns {undefined}
     */

  }, {
    key: "calculateCurLine",
    value: function calculateCurLine(evt) {
      var _this$props15 = this.props,
          annotationsMultiPageEnabled = _this$props15.annotationsMultiPageEnabled,
          _this$props15$current = _this$props15.currentDocument,
          currentDocument = _this$props15$current === void 0 ? document : _this$props15$current,
          drawingNode = _this$props15.drawingNode,
          nodeId = _this$props15.nodeId,
          scaleFactorX = _this$props15.scaleFactorX,
          scaleFactorY = _this$props15.scaleFactorY;
      var _this$state2 = this.state,
          curDrawing = _this$state2.curDrawing,
          curLine = _this$state2.curLine;
      var shouldCaptureDrawing = annotationsMultiPageEnabled ? nodeId === drawingNode : drawingNode !== undefined;

      if (shouldCaptureDrawing) {
        if (evt.buttons > 0 || evt.button === 0 || evt.touches && evt.touches.length === 1) {
          var _getPageCoordinatesFr2 = (0, _utils.getPageCoordinatesFromEvent)(evt),
              x = _getPageCoordinatesFr2.x,
              y = _getPageCoordinatesFr2.y;

          var bodyRect = currentDocument.body.getBoundingClientRect();

          var overlayRect = this._element.getBoundingClientRect();

          var overlayTop = overlayRect.top - bodyRect.top;
          var overlayLeft = overlayRect.left - bodyRect.left;
          var scaledX = (x - overlayLeft) / scaleFactorX;
          var scaledY = (y - overlayTop) / scaleFactorY;
          scaledX = Math.min(Math.max(0, scaledX), overlayRect.width / scaleFactorX);
          scaledY = Math.min(Math.max(0, scaledY), overlayRect.height / scaleFactorY);
          var newCurLine = curLine.concat([]);
          newCurLine.push({
            x: scaledX,
            y: scaledY
          });
          var newCurDrawing = curDrawing.concat([]);
          newCurDrawing.pop();
          newCurDrawing.push(newCurLine);
          this.setState({
            curDrawing: newCurDrawing,
            curLine: newCurLine
          });
        }
      }
    }
    /**
     * Handle a mouseDown on an annotation
     * @param {EventObject} evt - javascript event object
     * @returns {undefined}
     */

  }, {
    key: "handleAnnotationDown",
    value: function handleAnnotationDown(evt) {
      var _this3 = this;

      var _this$props16 = this.props,
          annotatingItmId = _this$props16.annotatingItmId,
          annotationsMultiPageEnabled = _this$props16.annotationsMultiPageEnabled,
          annotationLocationCoordinates = _this$props16.annotationLocationCoordinates,
          assetData = _this$props16.assetData,
          ccxIngest = _this$props16.ccxIngest,
          commentProposedForDelete = _this$props16.commentProposedForDelete,
          commentsListMinimized = _this$props16.commentsListMinimized,
          compactLayout = _this$props16.compactLayout,
          hasAnnotationLocation = _this$props16.hasAnnotationLocation,
          isPlacingAnnotation = _this$props16.isPlacingAnnotation,
          nodeId = _this$props16.nodeId,
          sectionId = _this$props16.sectionId,
          setAnnotationMode = _this$props16.setAnnotationMode,
          setClickedAnnotation = _this$props16.setClickedAnnotation,
          setCommentsListMinimized = _this$props16.setCommentsListMinimized,
          setSelectedAnnotationId = _this$props16.setSelectedAnnotationId,
          showResolvedComments = _this$props16.showResolvedComments;
      evt.preventDefault();

      if (annotationsMultiPageEnabled && nodeId !== assetData.nodeId) {
        var _ref5 = this.context || {},
            onNodeChange = _ref5.onNodeChange;

        onNodeChange(nodeId, sectionId);
        return;
      } // Dismiss keyboard when moving an annotation to correctly position CursorMarker


      if (compactLayout && document.activeElement && document.activeElement.classList.contains('textarea')) {
        document.activeElement.blur();
      }

      var _evt$target$closest$d = evt.target.closest('[data-annotationtype]').dataset,
          annotationId = _evt$target$closest$d.annotationid,
          annotationType = _evt$target$closest$d.annotationtype;

      if (this._hasTempAnnotation() && !(annotationId === 'annotation-placeholder' && annotatingItmId === 'root')) {
        return;
      }

      var _getClientCoordinates3 = (0, _utils.getClientCoordinatesFromEvent)(evt),
          x = _getClientCoordinates3.x,
          y = _getClientCoordinates3.y;

      if (annotationType === 'pin') {
        this.setState({
          offsetX: x - (evt.target.getBoundingClientRect().left + DIAMETER / 2),
          offsetY: y - (evt.target.getBoundingClientRect().top + DIAMETER / 2)
        });
      }

      setSelectedAnnotationId(annotationId);

      if (!isPlacingAnnotation && !commentProposedForDelete) {
        if (annotationId !== 'annotation-placeholder') {
          if (compactLayout) {
            this.annotationTouchStartTimerId = setTimeout(function () {
              if (_this3.annotationTouchStartTimerId) {
                _this3.annotationTouchStartTimerId = null;
              }

              if (commentsListMinimized) {
                setCommentsListMinimized(false);
              }

              setClickedAnnotation(annotationId);
            }, 200);
          } else {
            setClickedAnnotation(annotationId);
          }

          ccxIngest.fireEvent({
            event: {
              subcategory: 'navigation',
              type: 'click',
              subtype: annotationType
            }
          });
        }

        if (!showResolvedComments) {
          if (!compactLayout || evt.type === 'touchstart' || evt.pointerType && evt.pointerType !== 'mouse') {
            if (annotationId === 'annotation-placeholder' && (!annotatingItmId || annotatingItmId === 'root') && annotationLocationCoordinates.subtype === 'note') {
              setAnnotationMode(true);
            } else if (this._canMoveAnnotation(annotationId) && !hasAnnotationLocation) {
              this.moveTimer = setTimeout(function () {
                if (_this3.moveTimer) {
                  _this3.moveTimer = null;
                  setAnnotationMode(true, annotationId, true, 'pin');
                }
              }, 200);
            }
          }
        }
      }
    }
    /**
     * Handle a mouseover or mouseleave on an annotation
     * @param {EventObject} evt - javascript event object
     * @returns {undefined}
     */

  }, {
    key: "handleAnnotationHover",
    value: function handleAnnotationHover(evt) {
      var _this$props17 = this.props,
          isPlacingAnnotation = _this$props17.isPlacingAnnotation,
          setHoveredAnnotation = _this$props17.setHoveredAnnotation;

      if (!isPlacingAnnotation) {
        var annotationIdVal = evt.target.dataset && evt.target.dataset.annotationid;

        if (!annotationIdVal) {
          annotationIdVal = evt.target.closest('div').dataset.annotationid;
        }

        setHoveredAnnotation(evt.type === 'mouseenter' ? annotationIdVal : undefined);
      }
    }
    /**
     * Find the bounding box of the current drawing
     * @returns {undefined}
     */

  }, {
    key: "findDrawingBox",
    value: function findDrawingBox() {
      var curDrawing = this.state.curDrawing;
      var minX;
      var minY;
      var maxX;
      var maxY;
      curDrawing.forEach(function (line) {
        line.forEach(function (point) {
          if (!minX || point.x < minX) {
            minX = point.x;
          }

          if (!minY || point.y < minY) {
            minY = point.y;
          }

          if (!maxX || point.x > maxX) {
            maxX = point.x;
          }

          if (!maxY || point.y > maxY) {
            maxY = point.y;
          }
        });
      });
      return {
        minX: minX,
        maxX: maxX,
        minY: minY,
        maxY: maxY
      };
    }
    /**
     * End a current freehand drawing
     * @returns {undefined}
     */

  }, {
    key: "endDrawing",
    value: function endDrawing() {
      var _this$props18 = this.props,
          annotationColor = _this$props18.annotationColor,
          annotationsMultiPageEnabled = _this$props18.annotationsMultiPageEnabled,
          newAnnotationType = _this$props18.newAnnotationType,
          nodeId = _this$props18.nodeId,
          saveAnnotationLocation = _this$props18.saveAnnotationLocation,
          sectionId = _this$props18.sectionId,
          setDrawingNode = _this$props18.setDrawingNode;
      var curDrawing = this.state.curDrawing;

      var _this$findDrawingBox = this.findDrawingBox(),
          minX = _this$findDrawingBox.minX,
          maxX = _this$findDrawingBox.maxX,
          minY = _this$findDrawingBox.minY,
          maxY = _this$findDrawingBox.maxY;

      if (curDrawing.length) {
        saveAnnotationLocation({
          subtype: 'shape',
          boundingBox: [minX, minY, maxX, maxY],
          inkList: curDrawing,
          sectionId: sectionId,
          strokeColor: annotationColor
        }, annotationsMultiPageEnabled ? nodeId : undefined);
      }

      if (newAnnotationType === 'draw') {
        setDrawingNode(undefined);
      }
    }
    /**
     * Render an annotation point
     * @param {object} annotation - object holding data for current annotation
     * @returns {ReactElement} markup
     */

  }, {
    key: "renderAnnotation",
    value: function renderAnnotation(annotation) {
      var _this$props19 = this.props,
          annotationTypes = _this$props19.annotationTypes,
          commentProposedForDelete = _this$props19.commentProposedForDelete,
          compactLayout = _this$props19.compactLayout,
          hoveredAnnotation = _this$props19.hoveredAnnotation,
          touchPressed = _this$props19.touchPressed,
          showAnnotations = _this$props19.showAnnotations;
      var annotationType = (0, _lodash.default)(annotation, 'target.selector.subtype');
      var annotationId = annotation.id || 'annotation-placeholder';
      var commentProposedForDeleteId = (0, _lodash.default)(commentProposedForDelete, 'id');
      var isJustAdded = annotation.recentActivity === _constants.JUST_ADDED;
      var isJustEdited = annotation.recentActivity === _constants.JUST_EDITED;
      var isProposedForDelete = annotationId === commentProposedForDeleteId;
      var isPlaceHolder = annotationId === 'annotation-placeholder';
      var isHovered = hoveredAnnotation === annotationId;
      var renderedAnnotation;

      if (!showAnnotations && !isHovered && !isPlaceHolder && !isJustAdded && !isJustEdited && !isProposedForDelete) {
        return null;
      }

      if ((!annotationTypes || annotationTypes && annotationTypes.pin) && annotationType === 'note') {
        renderedAnnotation = /*#__PURE__*/_react.default.createElement(_Pin.default, _extends({}, this.props, {
          key: "annotation-marker-".concat(annotationId),
          touchPressed: touchPressed,
          annotation: annotation,
          onPinDown: this.handleAnnotationDown,
          onPinHover: compactLayout ? null : this.handleAnnotationHover,
          annotationId: annotationId
        }));
      } else if (annotationTypes && annotationTypes.draw && annotationType === 'shape') {
        renderedAnnotation = /*#__PURE__*/_react.default.createElement(_Drawing.default, _extends({}, this.props, {
          key: "annotation-marker-".concat(annotationId),
          annotation: annotation,
          onDrawingDown: this.handleAnnotationDown,
          onDrawingHover: compactLayout ? null : this.handleAnnotationHover,
          annotationId: annotationId
        }));
      } else if (annotationTypes && annotationTypes.highlight && annotationType === 'highlight') {
        renderedAnnotation = /*#__PURE__*/_react.default.createElement(_Highlight.default, _extends({}, this.props, {
          key: "annotation-marker-".concat(annotationId),
          annotation: annotation,
          onHighlightDown: this.handleAnnotationDown,
          onHighlightHover: compactLayout ? null : this.handleAnnotationHover,
          annotationId: annotationId
        }));
      } else if (annotationTypes && annotationTypes.strikethrough && annotationType === 'strikethrough') {
        renderedAnnotation = /*#__PURE__*/_react.default.createElement(_Strikethrough.default, _extends({}, this.props, {
          key: "annotation-marker-".concat(annotationId),
          annotation: annotation,
          onStrikethroughDown: this.handleAnnotationDown,
          onStrikethroughHover: compactLayout ? null : this.handleAnnotationHover,
          annotationId: annotationId
        }));
      } else if (annotationTypes && annotationTypes.insert && annotationType === 'insert') {
        renderedAnnotation = /*#__PURE__*/_react.default.createElement(_Insert.default, _extends({}, this.props, {
          key: "annotation-marker-".concat(annotationId),
          annotation: annotation,
          onInsertDown: this.handleAnnotationDown,
          onInsertHover: compactLayout ? null : this.handleAnnotationHover,
          annotationId: annotationId
        }));
      } else if (annotationTypes && annotationTypes.replace && annotationType === 'replace') {
        renderedAnnotation = /*#__PURE__*/_react.default.createElement(_Replace.default, _extends({}, this.props, {
          key: "annotation-marker-".concat(annotationId),
          annotation: annotation,
          onReplaceDown: this.handleAnnotationDown,
          onReplaceHover: compactLayout ? null : this.handleAnnotationHover,
          annotationId: annotationId
        }));
      }

      if ((isJustAdded || isJustEdited) && !isHovered) {
        return /*#__PURE__*/_react.default.createElement(_FadeOut.default, {
          key: annotationId,
          isVisible: showAnnotations
        }, renderedAnnotation);
      }

      return renderedAnnotation;
    }
    /**
     * Lifecycle method for rendering
     * @returns {ReactElement} markup
     */

  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props20 = this.props,
          annotationColor = _this$props20.annotationColor,
          annotationsEnabled = _this$props20.annotationsEnabled,
          annotationsMultiPageEnabled = _this$props20.annotationsMultiPageEnabled,
          annotationLocationCoordinates = _this$props20.annotationLocationCoordinates,
          annotationLocationNodeId = _this$props20.annotationLocationNodeId,
          annotationTypes = _this$props20.annotationTypes,
          currentDocument = _this$props20.currentDocument,
          drawingNode = _this$props20.drawingNode,
          hasAnnotationLocation = _this$props20.hasAnnotationLocation,
          isPlacingAnnotation = _this$props20.isPlacingAnnotation,
          newAnnotationType = _this$props20.newAnnotationType,
          nodeId = _this$props20.nodeId,
          annotatingItmId = _this$props20.annotatingItmId,
          registeredSectionIds = _this$props20.registeredSectionIds,
          sectionId = _this$props20.sectionId,
          showHighlight = _this$props20.showHighlight,
          style = _this$props20.style,
          scaleFactorX = _this$props20.scaleFactorX,
          scaleFactorY = _this$props20.scaleFactorY,
          selectedAnnotationId = _this$props20.selectedAnnotationId,
          spectrumUIScale = _this$props20.spectrumUIScale,
          touchControls = _this$props20.touchControls,
          viewingUnmapped = _this$props20.viewingUnmapped;
      var _this$state3 = this.state,
          curDrawing = _this$state3.curDrawing,
          offsetX = _this$state3.offsetX,
          offsetY = _this$state3.offsetY,
          showTempPin = _this$state3.showTempPin,
          pinSize = _this$state3.pinSize;

      if (!annotationsEnabled || viewingUnmapped) {
        return null;
      }

      var wrapperClasses = "".concat(_AnnotationsView.default.component, " ").concat(spectrumUIScale, "-scale");

      var annotations = this._getFilteredComments(); // If annotating, and not applying a text annotation type, apply classes to capture mouse events in the overlay


      if (isPlacingAnnotation && newAnnotationType !== 'highlight' && newAnnotationType !== 'strikethrough' && newAnnotationType !== 'replace' && newAnnotationType !== 'insert') {
        wrapperClasses += ' annotating-new';

        if (newAnnotationType === 'pin') {
          wrapperClasses += ' hide-cursor';
        }

        if (showHighlight) {
          wrapperClasses += ' highlight';
        }
      }

      if (this._hasTempAnnotation() && !(hasAnnotationLocation && newAnnotationType === 'insert') || !!selectedAnnotationId) {
        wrapperClasses += ' capture-pointer-events';
      }

      var addAnnotationClass;

      if (newAnnotationType) {
        if (isPlacingAnnotation && (this._isActiveOverlay(this.props) || !hasAnnotationLocation)) {
          addAnnotationClass = true;
        } else if (newAnnotationType === 'insert' && this._isActiveOverlay(this.props)) {
          addAnnotationClass = true;
        }
      }

      if (addAnnotationClass) {
        wrapperClasses += " addining-annotation-".concat(newAnnotationType);
      }

      if (hasAnnotationLocation && (!annotationsMultiPageEnabled || nodeId === annotationLocationNodeId) && (!sectionId && registeredSectionIds.length === 1 || sectionId === annotationLocationCoordinates.sectionId) || drawingNode !== undefined && curDrawing.length) {
        var tempAnnotationObj = {};

        if (drawingNode === undefined) {
          tempAnnotationObj.target = {
            selector: annotationLocationCoordinates
          };
        } else {
          var _this$findDrawingBox2 = this.findDrawingBox(),
              minX = _this$findDrawingBox2.minX,
              maxX = _this$findDrawingBox2.maxX,
              minY = _this$findDrawingBox2.minY,
              maxY = _this$findDrawingBox2.maxY;

          tempAnnotationObj.target = {
            selector: {
              subtype: 'shape',
              boundingBox: [minX, minY, maxX, maxY],
              inkList: curDrawing,
              strokeColor: annotationColor
            }
          };
        }

        annotations.unshift(tempAnnotationObj);
      }

      var pinOnlyAnnotations = annotations.filter(function (annotation) {
        return (0, _lodash.default)(annotation, 'target.selector.subtype') === 'note';
      });
      var existingPinColor;

      if (annotatingItmId) {
        var existingPinIdx = pinOnlyAnnotations.findIndex(function (annotation) {
          return annotation.id === annotatingItmId;
        });

        if (existingPinIdx > -1) {
          var existingPinData = pinOnlyAnnotations.find(function (annotation) {
            return annotation.id === annotatingItmId;
          });
          existingPinColor = (0, _lodash.default)(existingPinData, 'target.selector.strokeColor');
        }
      }

      var tempAnnotation;

      if (isPlacingAnnotation && this._isActiveOverlay(this.props) && (registeredSectionIds.length && registeredSectionIds[0] === sectionId || !sectionId)) {
        if (newAnnotationType === 'pin' && (!touchControls || touchControls && showTempPin)) {
          tempAnnotation = /*#__PURE__*/_react.default.createElement(_Pin.PinCursorMarker, {
            annotationTypes: annotationTypes,
            annotationColor: existingPinColor || annotationColor,
            currentDocument: currentDocument,
            offsetX: offsetX,
            offsetY: offsetY,
            touchControls: touchControls,
            size: pinSize,
            ref: this.handleCursorMarkerRef,
            onMove: this.handleCursorMarkerMove
          });
        }
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: wrapperClasses,
        id: _constants.ANNOTATION_COMPONENT_ID,
        onMouseEnter: this.handleOverlayEnter,
        onMouseLeave: this.handleOverlayLeave,
        onPointerDownCapture: POINTER_EVENTS_SUPPORTED ? this.handleGestureStart : undefined,
        onPointerUpCapture: POINTER_EVENTS_SUPPORTED ? this.handleGestureEnd : undefined,
        onTouchStartCapture: POINTER_EVENTS_SUPPORTED ? undefined : this.handleGestureStart,
        onTouchEndCapture: POINTER_EVENTS_SUPPORTED ? undefined : this.handleGestureEnd,
        onMouseDownCapture: POINTER_EVENTS_SUPPORTED ? undefined : this.handleGestureStart,
        onMouseUpCapture: POINTER_EVENTS_SUPPORTED ? undefined : this.handleGestureEnd,
        ref: this.handleOverlayRef,
        style: style,
        "data-sectionid": sectionId,
        "data-scalefactorx": scaleFactorX,
        "data-scalefactory": scaleFactorY,
        "data-nodeid": nodeId
      }, annotations.reverse().map(function (annotation) {
        return _this4.renderAnnotation(annotation);
      }), tempAnnotation);
    }
  }]);

  return Annotations;
}(_react.default.Component);

exports.default = Annotations;

_defineProperty(Annotations, "contextType", _CallbackContext.default);

Annotations.defaultProps = {
  ccxIngest: {
    fireEvent: function fireEvent() {}
  },
  isRoot: true,
  scaleFactorX: 1,
  scaleFactorY: 1,
  imageContextData: {},
  isOffline: false,
  onPinDrop: function onPinDrop() {},
  remapCommentNodes: function remapCommentNodes() {}
};
Annotations.propTypes = {
  annotationColor: _propTypes.default.string,
  annotationLocationCoordinates: _propTypes.default.object,
  annotationLocationNodeId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  annotationTypes: _propTypes.default.object,
  annotationsEnabled: _propTypes.default.bool,
  annotationsMultiPageEnabled: _propTypes.default.bool,
  assetData: _propTypes.default.object,
  ccxIngest: _propTypes.default.object.isRequired,
  commentProposedForDelete: _propTypes.default.object,
  comments: _propTypes.default.array,
  commentsListMinimized: _propTypes.default.bool,
  compactLayout: _propTypes.default.bool,
  currentDocument: _propTypes.default.object,
  drawingNode: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  focusedInputInfo: _propTypes.default.object,
  hasAnnotationLocation: _propTypes.default.bool,
  hoveredAnnotation: _propTypes.default.string,
  imageCapture: _propTypes.default.bool,
  imageContextData: _propTypes.default.object,
  imsData: _propTypes.default.shape({
    id: _propTypes.default.string,
    token: _propTypes.default.string
  }),
  isOffline: _propTypes.default.bool,
  isPlacingAnnotation: _propTypes.default.bool,
  mobileCommentsListOffsetTop: _propTypes.default.number,
  newAnnotationType: _propTypes.default.string,
  nodeId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  annotatingItmId: _propTypes.default.string,
  onPinDrop: _propTypes.default.func,
  registeredSectionIds: _propTypes.default.array,
  registerSectionId: _propTypes.default.func,
  remapCommentNodes: _propTypes.default.func,
  saveAnnotationLocation: _propTypes.default.func,
  saveImageCoordinatesInfo: _propTypes.default.func,
  scaleFactorX: _propTypes.default.number,
  scaleFactorY: _propTypes.default.number,
  sectionId: _propTypes.default.string,
  selectedAnnotationId: _propTypes.default.string,
  setAnnotationMode: _propTypes.default.func,
  setClickedAnnotation: _propTypes.default.func,
  setCommentsListMinimized: _propTypes.default.func,
  setDrawingNode: _propTypes.default.func,
  setHoveredAnnotation: _propTypes.default.func,
  setSelectedAnnotationId: _propTypes.default.func,
  setTouchPressed: _propTypes.default.func,
  showAnnotations: _propTypes.default.bool,
  showHighlight: _propTypes.default.bool,
  showResolvedComments: _propTypes.default.bool,
  spectrumUIScale: _propTypes.default.oneOf(['medium', 'large']),
  style: _propTypes.default.object,
  touchControls: _propTypes.default.bool,
  touchPressed: _propTypes.default.bool,
  viewingUnmapped: _propTypes.default.bool
};